import { render, staticRenderFns } from "./DesktopPageCybo.vue?vue&type=template&id=56cc82de&scoped=true&"
import script from "./DesktopPageCybo.vue?vue&type=script&lang=js&"
export * from "./DesktopPageCybo.vue?vue&type=script&lang=js&"
import style0 from "./DesktopPageCybo.vue?vue&type=style&index=0&id=56cc82de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cc82de",
  null
  
)

export default component.exports